<template>
  <DialogFull :data="dialogSettings" @close="close">
    <template v-slot:dialog.body>
      <div class="self-schedule-invitation container col-lg-8 col-sm-12">
        <div class="mt-5">
          <h1 class="mb-5">Schedule Interview</h1>
          <div v-if="isLoading">
            <v-skeleton-loader type="list-item-three-line" />
            <v-skeleton-loader
              type="date-picker-days"
              v-for="i in 2"
              class="mb-5"
              :key="i"
            />
          </div>
          <div v-else-if="currentInterviewFormat">
            <div class="d-flex align-center mb-2">
              <v-icon class="interview-icon" large>
                mdi-clipboard-text-outline
              </v-icon>
              <div clas="d-flex flex-column">
                <h2>
                  {{ currentInterviewFormat.interviewName | startCase }}
                </h2>
              </div>
            </div>
            <div
              class="rich-text-container"
              v-html="currentInterviewFormat.candidateDetails"
            />
            <SlotsSelection
              :showValidationErrors="showValidationErrors"
              :selectedSlot="selectedSlot"
              @select="val => (selectedSlot = val)"
              :slots="selfScheduleSlots"
            />
          </div>
        </div>
      </div>
    </template>
    <template v-slot:dialog.action>
      <PrimaryButton @click.native="handleSubmit" :loading="isSubmitting">
        Schedule Interview
      </PrimaryButton>
    </template>
  </DialogFull>
</template>

<script>
import DialogFull from "@/components/common/DialogFull";
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import { INTERVIEWS_NAMESPACE } from "@/store/modules/bookings/interviews";
import {
  FETCH_SELF_SCHEDULE_SLOTS,
  FETCH_INTERVIEW_FORMAT,
  ADD_SELF_SCHEDULE_SLOT_PARTICIPANT,
  FETCH_INTERVIEW_SLOTS
} from "@/store/modules/bookings/interviews/actions";
import { createNamespacedHelpers } from "vuex";
import { copyState } from "@/utils/helpers";
import SlotsSelection from "@/views/interviews/components/SlotsSelection";
import { size, first } from "lodash";

const {
  mapActions: mapInterviewActions,
  mapState: mapInterviewState
} = createNamespacedHelpers(INTERVIEWS_NAMESPACE);

export default {
  name: "SelfScheduleInvitation",
  components: {
    PrimaryButton,
    DialogFull,
    SlotsSelection
  },
  async created() {
    this.adjustRequestParams();
    if (!this.interviewFormatId) {
      this.closeDialog();
      return this.$router.push("pageNotFound");
    }
    await this.fetchInterviewSlots({
      filter: {
        interview_format_id: this.interviewFormatId,
        filled: 1,
        cancelled: 0
      }
    });
    if (size(this.interviewSlots)) {
      return this.$router.push(`interviews/${first(this.interviewSlots).id}`);
    }
    this.fetchInterviewFormat({
      interviewFormatId: this.interviewFormatId
    });
    this.fetchSelfScheduleSlots(this.interviewFormatId);
  },
  data() {
    return {
      isAddingSelfScheduleSlotParticipant: false,
      showValidationErrors: false,
      interviewFormatId: null,
      isSubmitting: false,
      selectedSlot: null,
      slots: []
    };
  },
  computed: {
    dialogSettings() {
      return {
        dialog: true,
        title: "Schedule Interview"
      };
    },
    isLoading() {
      return (
        this.isFetchingSelfScheduleSlots ||
        this.isFetchingInterviewFormat ||
        this.isFetchingInterviewSlots
      );
    },
    ...mapInterviewState(
      copyState([
        "isFetchingSelfScheduleSlots",
        "isFetchingInterviewFormat",
        "currentInterviewFormat",
        "selfScheduleSlots",
        "interviewSlots",
        "isFetchingInterviewSlots"
      ])
    )
  },
  methods: {
    ...mapInterviewActions({
      addSelfScheduleSlotParticipant: ADD_SELF_SCHEDULE_SLOT_PARTICIPANT,
      fetchSelfScheduleSlots: FETCH_SELF_SCHEDULE_SLOTS,
      fetchInterviewFormat: FETCH_INTERVIEW_FORMAT,
      fetchInterviewSlots: FETCH_INTERVIEW_SLOTS
    }),
    adjustRequestParams() {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      this.interviewFormatId = urlParams.get("interview_format_id");
    },
    async handleSubmit() {
      this.showValidationErrors = true;
      if (this.selectedSlot) {
        this.isSubmitting = true;
        await this.addSelfScheduleSlotParticipant({
          params: {
            interview_slot_id: this.selectedSlot.id
          },
          interviewFormatId: this.interviewFormatId
        });
        this.close();
        this.isSubmitting = false;
      }
    },
    closeDialog() {
      this.dialogSettings.dialog = false;
    },
    close() {
      this.$router.push("interviews");
    }
  }
};
</script>

<style lang="scss"></style>
